/*  
 *  Archivo que maneja la ventana que se utiliza para registrar o logear un usuario
 */

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useValue } from '../../context/ContextProvider'
import PasswordField from './PasswordField';
import { Send } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import GoogleOneTapLogin from './GoogleOneTapLogin';
import { register, login, useLogin } from '../../actions/user';
import { useAppStore } from '../../store/appStore.tsx';

const Login = () => {

    const { state: { }, dispatch } = useValue();
    const [title, setTitle] = useState('Login');
    const [isRegister, setIsRegister] = useState(false);
    const nameRef = useRef();
    const emailRef = useRef();
    const passwordRef = useRef();
    const confirmPasswordRef = useRef();

    const {showLogin, closeLogin} = useAppStore(appStore => appStore);
    const login = useLogin();

    //console.log(showLogin);

    const handleClose = () => {
        //dispatch({ type: 'CLOSE_LOGIN' });
        closeLogin();
    }
    const handleSubmit = (e) => {
        e.preventDefault();

        const email = emailRef.current.value;
        const password = passwordRef.current.value;
        //se debe enviar la solicitud de login si es que el usuario no esta registrandose como nuevo usuario
        if(!isRegister) {
            //login({email, password}, dispatch, updateUser);
            login({email, password});
        } else {
            const name = nameRef.current.value;
            const confirmPassword = confirmPasswordRef.current.value;
            if(password !== confirmPassword) {
                return dispatch({type: 'UPDATE_ALERT', payload: {open:true, severity: 'error', message: 'Las contraseñas no coinciden.'}})
            }
            //Enviar solicitud de registro
            register({name, email, password}, dispatch);
        }
    }

    useEffect(() => {
        isRegister ? setTitle('Registrarse') : setTitle('Login');
    }, [isRegister])

    return (
        <Dialog
            open={showLogin}
            onClose={handleClose}
        >
            <DialogTitle>
                {title}
                <IconButton
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={handleClose}
                >
                    <CancelIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent dividers>
                    <DialogContentText>
                        Por favor ingrese su información en los siguientes campos:
                    </DialogContentText>
                    {isRegister &&
                        <TextField
                            autoFocus
                            margin='normal'
                            variant='standard'
                            id='name'
                            label='Nombre'
                            type='text'
                            fullWidth
                            inputRef={nameRef}
                            inputProps={{ minLength: 2 }}
                            required
                        />
                    }
                    <TextField
                        autoFocus={!isRegister}
                        margin='normal'
                        variant='standard'
                        id='email'
                        type='email'
                        label='Email'
                        fullWidth
                        inputRef={emailRef}
                        required
                    />
                    <PasswordField {...{ passwordRef }} />
                    {isRegister && <PasswordField passwordRef={confirmPasswordRef} id='confirmPassword' label='Confirmar Contraseña' />}
                </DialogContent>
                <DialogActions sx={{pr: '22px', pt: '20px'}}>
                    <Button type='submit' variant='contained' endIcon={<Send />}>
                        Enviar
                    </Button>
                </DialogActions>
            </form>
            <DialogActions sx={{ justifyContent: 'left', p: '5px 24px' }}>
                {isRegister ? 'Si tiene ya una cuenta, por favor ingrese ' : 'No tiene una cuenta, creéla ahora '}
                <Button onClick={() => setIsRegister(!isRegister)}>
                    {isRegister ? 'Login' : 'Registrarse'}
                </Button>
            </DialogActions>
            <DialogActions sx={{ justifyContent: 'center', py: '24px' }}>
                <GoogleOneTapLogin />
            </DialogActions>

        </Dialog>
    )
}

export default Login